export default {
	path: 'esignWhiteList',
	component: () => import( /* webpackChunkName: "taskBillWhitelist" */ '@/pages/esignWhiteList/list'),
	meta: {
		title: 'E签宝白名单列表'
	},
}